import { authenticatedFetch } from "services/api";
import { WHOLSTER_REST_BASE_URL } from "services/config";

export async function propertyOrdersRequest(path, sessionId, options = {}) {
  const response = await authenticatedFetch(
    `${WHOLSTER_REST_BASE_URL}/propertyOrders/${path}`,
    sessionId,
    {
      ...options,
      headers: {
        Accept: "application/json",
        ...options.headers,
      },
    }
  );

  if (!response.ok) {
    let message = `Order request failed with status ${response.status}.`;

    try {
      const error = await response.json();
      message = error.message || error.error || message;
    } catch (error) {
      // Preserve the status-based message for non-JSON error responses.
    }

    const requestError = new Error(message);
    requestError.status = response.status;
    throw requestError;
  }

  if (response.status === 204) return null;

  const text = await response.text();
  if (!text) return null;

  try {
    return JSON.parse(text);
  } catch (error) {
    return text;
  }
}

export const unwrapOrders = (response) => {
  const data = response?.data ?? response;
  if (Array.isArray(data)) return data;
  return data?.orders || data?.propertyOrders || [];
};